import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37b8d61a&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=37b8d61a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8d61a",
  null
  
)

export default component.exports